export default __webpack_public_path__ + "static/media/darkNet.ab6410de.jpg";